import React, { FC } from 'react'
import Box from '../Box'
import Text from '../Text'
import { TagStyled } from './styled'
import { TagProps } from './types'

const Tag: FC<TagProps> = ({
  text,
  textVariant = 'caption-small',
  iconLeft,
  iconRight,
  ...props
}) => {
  return (
    // @ts-ignore
    <TagStyled {...props}>
      <Text
        variant={textVariant}
        display="flex"
        alignItems="center"
        flexDirection="row">
        {iconLeft && (
          <Box lineHeight={0} mr="4px" fontSize="1.2em">
            {iconLeft}
          </Box>
        )}

        <Text variant={textVariant}>{text}</Text>

        {iconRight && (
          <Box lineHeight={0} ml="4px" fontSize="1em">
            {iconRight}
          </Box>
        )}
      </Text>
    </TagStyled>
  )
}

export default Tag
